/**
 * PageSizeSelect — a small, framework-agnostic "Rows per page" dropdown used to
 * give every data table a consistent 10 / 20 / 50 page-size control (default 10).
 *
 * Usage:
 *   const [pageSize, setPageSize] = useState(10);
 *   <PageSizeSelect value={pageSize} onChange={(n) => { setPageSize(n); setPage(1); }} />
 *
 * Keep the reset-to-page-1 in the caller so it works with whatever page state
 * the table already has.
 */
export const PAGE_SIZE_OPTIONS = [10, 20, 50];

export default function PageSizeSelect({
  value = 10,
  onChange,
  options = PAGE_SIZE_OPTIONS,
  className = "",
  label = "Rows per page",
}) {
  return (
    <div className={`d-inline-flex align-items-center gap-2 ${className}`} style={{ fontSize: 13 }}>
      <span className="text-muted">{label}</span>
      <select
        className="form-select form-select-sm"
        style={{ width: "auto", minWidth: 70 }}
        value={value}
        onChange={(e) => onChange?.(Number(e.target.value))}
        aria-label={label}
      >
        {options.map((n) => (
          <option key={n} value={n}>{n}</option>
        ))}
      </select>
    </div>
  );
}
